<template>
  <div>
    <div class="row-fluid">
      <!--最新活动-->
      <div class="span12 text-left">
        <div style="padding-bottom: 10px">
          <img style="width: 100%" :src="models.imgages_b" />
        </div>
        <div>
          <button
            class="btn3"
            @click="binWin(1)"
            style="
              display: block;
              margin: 15px auto 0;
              outline: none;
              color: #666;
              width: 50%;
              background-color: #eee;
              height: 40px;
            "
          >
            我要预约报名
          </button>
        </div>
        <div style="margin-top: 20px">
          <h4>{{ models.title }}</h4>
          <div class="row">
            <div
              class="col-12"
              style="text-indent: 2em; font-size: 15px; line-height: 35px"
            >
              <samp v-html="models.detailed"></samp>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 30px"></div>
    </div>

    <div class="edit_activity" v-show="show">
      <div class="tt_10 tt_x_10">
        <h4 class="text-left">个人资料</h4>
      </div>
      <br />
      <div class="row">
        <div class="col-12">
          <div class="input-group">
            <span class="input-group-addon">联系姓名</span>
            <input
              type="text"
              class="form-control"
              style="
                border: 1px solid #ccc !important;
                padding-left: 12px !important;
              "
              placeholder="填写真实姓名"
              v-model="ruleForm.username"
            />
          </div>
          <br />
          <div class="input-group">
            <span class="input-group-addon">联系电话</span>
            <input
              type="text"
              class="form-control"
              style="
                border: 1px solid #ccc !important;
                padding-left: 12px !important;
              "
              placeholder="填写联系电话"
              v-model="ruleForm.telephone"
            />
          </div>
          <br />
          <div class="input-group">
            <span class="input-group-addon">报名人数</span>
            <input
              type="text"
              class="form-control"
              style="
                border: 1px solid #ccc !important;
                padding-left: 12px !important;
              "
              placeholder="填写报名人数"
              v-model="ruleForm.people"
            />
          </div>

          <br />
          <div class="input-group">
            <textarea
              rows="2"
              v-model="ruleForm.describe"
              class="form-control"
              placeholder="详细描述"
            ></textarea>
          </div>
          <br />
          <div class="col-12 text-center">
            <el-button type="info" @click="binWin(0)">关闭窗口</el-button>
            <el-button type="primary" @click="binAdd()">提交数据</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      models: {},
      ruleForm: {
        username: "", //用户姓名
        telephone: "", //用户手机
        people: "", //用户地址
        describe: "", //描述
      },
    };
  },
  methods: {
    binWin(v) {
      if (v == 0) {
        this.show = false;
        return;
      }
      console.log("res.data.data.models");
      this.show = true;
    },
    binAdd() {},
    sel(id) {
      //data/activity/?token=0&appid=202011&type_id=20201108
      this.$api
        .getAPI("data/activity/" + id + "?type_id=20201108&state=1", {})
        .then((res) => {
          console.log(res.data.data.models);
          this.models = res.data.data.models;
        });
    },
  },
  mounted() {
    var id = this.$route.query.id;
    this.sel(id);
  },
};
</script>

<style scoped>
.input-group input {
  border: 1px solid #ccc;
  padding-left: 12px;
}

.label-primary {
  color: #3480fa;
  background-color: #dcdfe6;
}

.label_50 {
  border-radius: 50px/50px;
}

.i2 {
  position: absolute;
  right: 30px;
  top: 106px;
  font-size: 25px !important;
}

.ic2 {
  position: absolute;
  right: 30px;
  top: 112px;
  font-size: 18px !important;
  color: #ffd986;
}

.i3 {
  position: absolute;
  right: 25px;
  top: 56px;
  font-size: 25px !important;
}

.ic3 {
  position: absolute;
  right: 25px;
  top: 60px;
  font-size: 18px !important;
  color: #ffd986;
}

.pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.edit_activity {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 5px;
  padding: 30px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit h4 {
  margin: 0;
}

.container-fluid-a {
  position: absolute;
  top: 50px;
}

.is {
  width: 50px;
  text-align: center;
  line-height: 25px;
  height: 50px;
  font-size: 14px;
  border: 1px solid #c0c0c0;
}

.jumbotron {
  margin-bottom: 20px;
  border-radius: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/show_activity.vue